import { Box, Checkbox, Paper, Stack, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { MISC_PRIMARY } from '../../theme/onboardingTheme'

const videos = [
  { title: 'Portal navigation basics', id: 'demo-loom-1' },
  { title: 'Surplus lines filing queue', id: 'demo-loom-2' },
  { title: 'OTR attestation overview', id: 'demo-loom-3' },
]

export function StepTraining() {
  const { state, dispatch } = useOnboarding()

  return (
    <Stack spacing={3}>
      <Typography sx={{ fontSize: 14, color: '#475569' }}>
        Training videos would be embedded Loom links in production. Below are placeholders.
      </Typography>
      <Stack component="ul" spacing={1.5} sx={{ m: 0, p: 0, listStyle: 'none' }}>
        {videos.map((v) => (
          <Paper
            component="li"
            key={v.id}
            variant="outlined"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderColor: '#e2e8f0',
              borderRadius: '12px',
              backgroundColor: '#ffffff',
              px: 2,
              py: 1.5,
              boxShadow: 1,
            }}
          >
            <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#0f172a' }}>{v.title}</Typography>
            <Typography sx={{ fontSize: 12, fontWeight: 600, color: MISC_PRIMARY }}>
              Watch (mock)
            </Typography>
          </Paper>
        ))}
      </Stack>
      <Box
        component="label"
        sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, fontSize: 14, color: '#334155' }}
      >
        <Checkbox
          checked={state.trainingCompleted}
          onChange={() => dispatch({ type: 'TOGGLE_TRAINING' })}
          sx={{ mt: -0.5, p: 0.5 }}
        />
        <Box component="span">I have completed the onboarding training for my selected services.</Box>
      </Box>
    </Stack>
  )
}
